import React, {useState, ReactElement} from 'react'
import styled from 'styled-components'

import {Box, Close} from '@miro-site/core'

interface PreviewExperimentsProps {
  previewExperiments: Record<string, string[]>
  selectedTreatments: Record<string, string>
  setSelectedTreatments: (treatments: Record<string, string>) => void
}

const Wrapper = styled(Box)`
  padding: 15px;
  margin-bottom: 55px;
  position: relative;

  p + p {
    margin-top: 10px;
  }
`

const ExperimentsWrapper = styled(Box)`
  margin-top: 15px;

  div + div {
    margin-top: 10px;
  }

  select {
    margin-left: 10px;
  }
`

const ToggleWrapper = styled.div`
  cursor: pointer;
  padding: 5px;
  opacity: 0.5;
  position: absolute;
  transition: opacity 400ms;
  right: 30px;

  &:hover {
    opacity: 1;
  }
`

const PreviewExperiments = ({
  previewExperiments,
  selectedTreatments,
  setSelectedTreatments,
}: PreviewExperimentsProps): ReactElement | null => {
  const [isClosed, setIsClosed] = useState(false)
  const experiments = Object.keys(previewExperiments)

  if (experiments.length === 0) {
    return null
  }

  const handleChange = experiment => e => {
    setSelectedTreatments({
      ...selectedTreatments,
      [experiment]: e.target.value,
    })
  }

  const toggleWrapper = () => {
    setIsClosed(!isClosed)
  }

  const getContent = () => {
    if (isClosed) {
      return <ToggleWrapper onClick={toggleWrapper}>Open experiments selector</ToggleWrapper>
    }

    return (
      <>
        <ToggleWrapper onClick={toggleWrapper}>
          <Close width={15} />
        </ToggleWrapper>
        <p>This page contains experiment sections. </p>
        <p>
          You can change which value is applied to each treatment in order to preview the different
          possibilities for this page.
        </p>

        <ExperimentsWrapper>
          {experiments.map((experiment, i) => {
            return (
              <div key={i}>
                <label>
                  {experiment}:
                  <select
                    onChange={handleChange(experiment)}
                    value={selectedTreatments[experiment]}
                  >
                    {previewExperiments[experiment].map((variant, j) => {
                      return (
                        <option key={j} value={variant}>
                          {variant}
                        </option>
                      )
                    })}
                  </select>
                </label>
              </div>
            )
          })}
        </ExperimentsWrapper>
      </>
    )
  }

  return <Wrapper>{getContent()}</Wrapper>
}

export default PreviewExperiments
